import React from 'react'
import { InstallationInvitationModel } from 'src/Libs/installation-rights-management/models'
import { Chip } from 'src/Components'
import { useTheme } from '@mui/material'
import { Installation } from 'src/Libs/installations'

interface Props {
  invitation?: InstallationInvitationModel
  invitationLoading: boolean
  installation?: Installation
}

const OwnerInvitationStatus: React.FC<Props> = ({ invitation, invitationLoading, installation }) => {
  const theme = useTheme()

  const textKey = installation?.ownerAccountId
    ? 'installation-configuration.owner-settings.invitation-accepted'
    : invitation
    ? 'installation-configuration.owner-settings.invitation-pending'
    : 'installation-configuration.owner-settings.no-invitation'

  return (
    <Chip
      textKey={textKey}
      paletteColor={installation?.ownerAccountId || invitation ? theme.palette.primary : undefined}
      isLoading={invitationLoading}
      variant={invitation ? 'light' : 'main'}
    />
  )
}

export default OwnerInvitationStatus
